/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.4.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AssociationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://127.0.0.1:8000/api";
    }

    /**
     * @return Association request completed
     */
    association(data: RelativeAssociationRequest , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/association/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssociation(_response);
        });
    }

    protected processAssociation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some validation errors", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class AuthClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://127.0.0.1:8000/api";
    }

    /**
     * @return Logged user is been logout
     */
    logout(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/auth/logout/";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Error in authentication", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    token(data: Login , cancelToken?: CancelToken | undefined): Promise<TokenLoginResponse> {
        let url_ = this.baseUrl + "/auth/token/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToken(_response);
        });
    }

    protected processToken(response: AxiosResponse): Promise<TokenLoginResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TokenLoginResponse.fromJS(resultData200);
            return result200;
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("If user is not a parent", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenLoginResponse>(<any>null);
    }

    refresh(data: TokenRefresh , cancelToken?: CancelToken | undefined): Promise<TokenRefreshResponse> {
        let url_ = this.baseUrl + "/auth/token/refresh/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefresh(_response);
        });
    }

    protected processRefresh(response: AxiosResponse): Promise<TokenRefreshResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TokenRefreshResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Invalid token", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenRefreshResponse>(<any>null);
    }
}

export class ContentsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://127.0.0.1:8000/api";
    }

    /**
     * @return Content hidden
     */
    hideOperatorMessage(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/contents/hide-operator-message/{id}/";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHideOperatorMessage(_response);
        });
    }

    protected processHideOperatorMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Error in authentication", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Patient message created
     */
    patientMessage(data: PatientMessageCreate, patient_id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/contents/patient-message/{patient_id}/";
        if (patient_id === undefined || patient_id === null)
            throw new Error("The parameter 'patient_id' must be defined.");
        url_ = url_.replace("{patient_id}", encodeURIComponent("" + patient_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPatientMessage(_response);
        });
    }

    protected processPatientMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Error in authentication", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Question created created
     */
    question(data: QuestionCreate, patient_id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/contents/question/{patient_id}/";
        if (patient_id === undefined || patient_id === null)
            throw new Error("The parameter 'patient_id' must be defined.");
        url_ = url_.replace("{patient_id}", encodeURIComponent("" + patient_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestion(_response);
        });
    }

    protected processQuestion(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Error in authentication", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    contents(patient_id: string , cancelToken?: CancelToken | undefined): Promise<Content[]> {
        let url_ = this.baseUrl + "/contents/{patient_id}/";
        if (patient_id === undefined || patient_id === null)
            throw new Error("The parameter 'patient_id' must be defined.");
        url_ = url_.replace("{patient_id}", encodeURIComponent("" + patient_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContents(_response);
        });
    }

    protected processContents(response: AxiosResponse): Promise<Content[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Content.fromJS(item));
            }
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Error in authentication", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Content[]>(<any>null);
    }
}

export class ExtractFiscalCodeDataClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://127.0.0.1:8000/api";
    }

    extractFiscalCodeData(data: FiscalCode , cancelToken?: CancelToken | undefined): Promise<FiscalCodeData> {
        let url_ = this.baseUrl + "/extract-fiscal-code-data/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExtractFiscalCodeData(_response);
        });
    }

    protected processExtractFiscalCodeData(response: AxiosResponse): Promise<FiscalCodeData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FiscalCodeData.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Invalid fiscal code", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FiscalCodeData>(<any>null);
    }
}

export class FileGenTokenClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://127.0.0.1:8000/api";
    }

    fileGenToken(filetype: string, id: string , cancelToken?: CancelToken | undefined): Promise<FileToken> {
        let url_ = this.baseUrl + "/file-gen-token/{filetype}/{id}/";
        if (filetype === undefined || filetype === null)
            throw new Error("The parameter 'filetype' must be defined.");
        url_ = url_.replace("{filetype}", encodeURIComponent("" + filetype));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileGenToken(_response);
        });
    }

    protected processFileGenToken(response: AxiosResponse): Promise<FileToken> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileToken.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Error in authentication", status, _responseText, _headers);
        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("File not found", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileToken>(<any>null);
    }
}

export class FileClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://127.0.0.1:8000/api";
    }

    token(token: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/file/download/token/{token}/";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToken(_response);
        });
    }

    protected processToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    download(filetype: string, id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/file/download/{filetype}/{id}/";
        if (filetype === undefined || filetype === null)
            throw new Error("The parameter 'filetype' must be defined.");
        url_ = url_.replace("{filetype}", encodeURIComponent("" + filetype));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class JitsiClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://127.0.0.1:8000/api";
    }

    /**
     * @return Last seen updated
     */
    hasJitsiCall(patient_id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/jitsi/has-jitsi-call/{patient_id}/";
        if (patient_id === undefined || patient_id === null)
            throw new Error("The parameter 'patient_id' must be defined.");
        url_ = url_.replace("{patient_id}", encodeURIComponent("" + patient_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasJitsiCall(_response);
        });
    }

    protected processHasJitsiCall(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Error in authentication", status, _responseText, _headers);
        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No jitsi call", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    roomData(patient_id: string , cancelToken?: CancelToken | undefined): Promise<JitsiRoomData> {
        let url_ = this.baseUrl + "/jitsi/room-data/{patient_id}/";
        if (patient_id === undefined || patient_id === null)
            throw new Error("The parameter 'patient_id' must be defined.");
        url_ = url_.replace("{patient_id}", encodeURIComponent("" + patient_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoomData(_response);
        });
    }

    protected processRoomData(response: AxiosResponse): Promise<JitsiRoomData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JitsiRoomData.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("No active jitsi call", status, _responseText, _headers);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Error in authentication", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JitsiRoomData>(<any>null);
    }

    /**
     * @return Last seen updated
     */
    updateLastSeen(patient_id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/jitsi/update-last-seen/{patient_id}/";
        if (patient_id === undefined || patient_id === null)
            throw new Error("The parameter 'patient_id' must be defined.");
        url_ = url_.replace("{patient_id}", encodeURIComponent("" + patient_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLastSeen(_response);
        });
    }

    protected processUpdateLastSeen(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("No active jitsi call", status, _responseText, _headers);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Error in authentication", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class MeClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://127.0.0.1:8000/api";
    }

    me(  cancelToken?: CancelToken | undefined): Promise<Identity> {
        let url_ = this.baseUrl + "/me/";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: AxiosResponse): Promise<Identity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Identity.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Error in authentication", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Identity>(<any>null);
    }
}

export class PasswordClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://127.0.0.1:8000/api";
    }

    /**
     * @return Email sent if there is an user with that email
     */
    recovery(data: RecoveryPassword , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/password/recovery/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecovery(_response);
        });
    }

    protected processRecovery(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Malformed email", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class RegisterDeviceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://127.0.0.1:8000/api";
    }

    /**
     * @return Device registered
     */
    registerDevice(data: RegisterDevice , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/register-device/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterDevice(_response);
        });
    }

    protected processRegisterDevice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some error occurred", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class RegistrationUploadClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://127.0.0.1:8000/api";
    }

    registrationUploadPost(data: UploadRegistrationFile , cancelToken?: CancelToken | undefined): Promise<UploadRegistrationFile> {
        let url_ = this.baseUrl + "/registration-upload/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegistrationUploadPost(_response);
        });
    }

    protected processRegistrationUploadPost(response: AxiosResponse): Promise<UploadRegistrationFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = UploadRegistrationFile.fromJS(resultData201);
            return result201;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadRegistrationFile>(<any>null);
    }

    registrationUploadDelete(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/registration-upload/{id}/";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegistrationUploadDelete(_response);
        });
    }

    protected processRegistrationUploadDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class RegistrationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://127.0.0.1:8000/api";
    }

    /**
     * @return Registration completed
     */
    registration(data: RelativeRegistration , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/registration/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegistration(_response);
        });
    }

    protected processRegistration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some validation errors", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class RequestPatientTransferClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://127.0.0.1:8000/api";
    }

    tokenValidation(data: PatientTransferTokenValidationRequest , cancelToken?: CancelToken | undefined): Promise<PatientTransferTokenValidationResponse> {
        let url_ = this.baseUrl + "/request-patient-transfer/token-validation/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTokenValidation(_response);
        });
    }

    protected processTokenValidation(response: AxiosResponse): Promise<PatientTransferTokenValidationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PatientTransferTokenValidationResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Invalid code", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PatientTransferTokenValidationResponse>(<any>null);
    }

    /**
     * @return OK
     */
    transfer(data: PatientTransferRequest , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/request-patient-transfer/transfer/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransfer(_response);
        });
    }

    protected processTransfer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Validation error", status, _responseText, _headers);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Error in authentication", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    requestPatientTransfer(data: RequestPatientTransferRequest, patient_id: string , cancelToken?: CancelToken | undefined): Promise<RequestPatientTransferResponse> {
        let url_ = this.baseUrl + "/request-patient-transfer/{patient_id}/";
        if (patient_id === undefined || patient_id === null)
            throw new Error("The parameter 'patient_id' must be defined.");
        url_ = url_.replace("{patient_id}", encodeURIComponent("" + patient_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestPatientTransfer(_response);
        });
    }

    protected processRequestPatientTransfer(response: AxiosResponse): Promise<RequestPatientTransferResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RequestPatientTransferResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Validation error", status, _responseText, _headers);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Error in authentication", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RequestPatientTransferResponse>(<any>null);
    }
}

export class SendVerificationSmsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://127.0.0.1:8000/api";
    }

    /**
     * @return SMS Verification sent
     */
    sendVerificationSms(data: SendSmsVerification , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/send-verification-sms/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendVerificationSms(_response);
        });
    }

    protected processSendVerificationSms(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some error occurred", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class UploadClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://127.0.0.1:8000/api";
    }

    uploadPost(data: UploadFile , cancelToken?: CancelToken | undefined): Promise<UploadFile> {
        let url_ = this.baseUrl + "/upload/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadPost(_response);
        });
    }

    protected processUploadPost(response: AxiosResponse): Promise<UploadFile> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = UploadFile.fromJS(resultData201);
            return result201;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadFile>(<any>null);
    }

    uploadDelete(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/upload/{id}/";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadDelete(_response);
        });
    }

    protected processUploadDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class VerifySmsTokenClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://127.0.0.1:8000/api";
    }

    verifySmsToken(data: VerifySmsTokenRequest , cancelToken?: CancelToken | undefined): Promise<VerifySmsTokenResponse> {
        let url_ = this.baseUrl + "/verify-sms-token/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifySmsToken(_response);
        });
    }

    protected processVerifySmsToken(response: AxiosResponse): Promise<VerifySmsTokenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VerifySmsTokenResponse.fromJS(resultData200);
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Some error occurred", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VerifySmsTokenResponse>(<any>null);
    }
}

export class RelativeAssociationRequest implements IRelativeAssociationRequest {
    relation?: RelativeAssociationRequestRelation | undefined;
    patientFirstName!: string;
    patientLastName!: string;
    patientBirthCity?: string | undefined;
    patientFiscalCode!: string;
    confirmClosestRelative!: boolean;
    confirmPrivacy!: boolean;
    confirmEmail!: boolean;
    confirmPersonalData!: boolean;
    isEmergencyRoom?: boolean | undefined;

    constructor(data?: IRelativeAssociationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relation = _data["relation"];
            this.patientFirstName = _data["patientFirstName"];
            this.patientLastName = _data["patientLastName"];
            this.patientBirthCity = _data["patientBirthCity"];
            this.patientFiscalCode = _data["patientFiscalCode"];
            this.confirmClosestRelative = _data["confirmClosestRelative"];
            this.confirmPrivacy = _data["confirmPrivacy"];
            this.confirmEmail = _data["confirmEmail"];
            this.confirmPersonalData = _data["confirmPersonalData"];
            this.isEmergencyRoom = _data["isEmergencyRoom"];
        }
    }

    static fromJS(data: any): RelativeAssociationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RelativeAssociationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relation"] = this.relation;
        data["patientFirstName"] = this.patientFirstName;
        data["patientLastName"] = this.patientLastName;
        data["patientBirthCity"] = this.patientBirthCity;
        data["patientFiscalCode"] = this.patientFiscalCode;
        data["confirmClosestRelative"] = this.confirmClosestRelative;
        data["confirmPrivacy"] = this.confirmPrivacy;
        data["confirmEmail"] = this.confirmEmail;
        data["confirmPersonalData"] = this.confirmPersonalData;
        data["isEmergencyRoom"] = this.isEmergencyRoom;
        return data; 
    }
}

export interface IRelativeAssociationRequest {
    relation?: RelativeAssociationRequestRelation | undefined;
    patientFirstName: string;
    patientLastName: string;
    patientBirthCity?: string | undefined;
    patientFiscalCode: string;
    confirmClosestRelative: boolean;
    confirmPrivacy: boolean;
    confirmEmail: boolean;
    confirmPersonalData: boolean;
    isEmergencyRoom?: boolean | undefined;
}

export class Login implements ILogin {
    username!: string;
    password!: string;

    constructor(data?: ILogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): Login {
        data = typeof data === 'object' ? data : {};
        let result = new Login();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILogin {
    username: string;
    password: string;
}

export class TokenLoginResponse implements ITokenLoginResponse {
    readonly access?: string | undefined;
    readonly refresh?: string | undefined;

    constructor(data?: ITokenLoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).access = _data["access"];
            (<any>this).refresh = _data["refresh"];
        }
    }

    static fromJS(data: any): TokenLoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TokenLoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access"] = this.access;
        data["refresh"] = this.refresh;
        return data; 
    }
}

export interface ITokenLoginResponse {
    access?: string | undefined;
    refresh?: string | undefined;
}

export class TokenRefresh implements ITokenRefresh {
    refresh!: string;

    constructor(data?: ITokenRefresh) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refresh = _data["refresh"];
        }
    }

    static fromJS(data: any): TokenRefresh {
        data = typeof data === 'object' ? data : {};
        let result = new TokenRefresh();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refresh"] = this.refresh;
        return data; 
    }
}

export interface ITokenRefresh {
    refresh: string;
}

export class TokenRefreshResponse implements ITokenRefreshResponse {
    readonly access?: string | undefined;

    constructor(data?: ITokenRefreshResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).access = _data["access"];
        }
    }

    static fromJS(data: any): TokenRefreshResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TokenRefreshResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access"] = this.access;
        return data; 
    }
}

export interface ITokenRefreshResponse {
    access?: string | undefined;
}

export class PatientMessageCreate implements IPatientMessageCreate {
    message!: string;
    attachment?: string | undefined;

    constructor(data?: IPatientMessageCreate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.attachment = _data["attachment"];
        }
    }

    static fromJS(data: any): PatientMessageCreate {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMessageCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["attachment"] = this.attachment;
        return data; 
    }
}

export interface IPatientMessageCreate {
    message: string;
    attachment?: string | undefined;
}

export class QuestionCreate implements IQuestionCreate {
    message!: string;

    constructor(data?: IQuestionCreate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): QuestionCreate {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data; 
    }
}

export interface IQuestionCreate {
    message: string;
}

export class Answer implements IAnswer {
    message!: string;
    created!: Date;
    attachment!: string | undefined;
    attachmentMimeType!: string | undefined;
    expiration!: Date | undefined;

    constructor(data?: IAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.attachment = _data["attachment"];
            this.attachmentMimeType = _data["attachmentMimeType"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Answer {
        data = typeof data === 'object' ? data : {};
        let result = new Answer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["attachment"] = this.attachment;
        data["attachmentMimeType"] = this.attachmentMimeType;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IAnswer {
    message: string;
    created: Date;
    attachment: string | undefined;
    attachmentMimeType: string | undefined;
    expiration: Date | undefined;
}

export class Content implements IContent {
    id!: number | undefined;
    type!: ContentType;
    message!: string;
    created!: Date;
    attachment!: string | undefined;
    attachmentTokenUrl!: string | undefined;
    attachmentMimeType!: string | undefined;
    canBeHidden?: boolean | undefined;
    answer!: Answer | undefined;
    expiration!: Date | undefined;

    constructor(data?: IContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.canBeHidden = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.message = _data["message"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.attachment = _data["attachment"];
            this.attachmentTokenUrl = _data["attachmentTokenUrl"];
            this.attachmentMimeType = _data["attachmentMimeType"];
            this.canBeHidden = _data["canBeHidden"] !== undefined ? _data["canBeHidden"] : false;
            this.answer = _data["answer"] ? Answer.fromJS(_data["answer"]) : <any>undefined;
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Content {
        data = typeof data === 'object' ? data : {};
        let result = new Content();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["message"] = this.message;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["attachment"] = this.attachment;
        data["attachmentTokenUrl"] = this.attachmentTokenUrl;
        data["attachmentMimeType"] = this.attachmentMimeType;
        data["canBeHidden"] = this.canBeHidden;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IContent {
    id: number | undefined;
    type: ContentType;
    message: string;
    created: Date;
    attachment: string | undefined;
    attachmentTokenUrl: string | undefined;
    attachmentMimeType: string | undefined;
    canBeHidden?: boolean | undefined;
    answer: Answer | undefined;
    expiration: Date | undefined;
}

export class FiscalCode implements IFiscalCode {
    fiscalCode!: string;

    constructor(data?: IFiscalCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fiscalCode = _data["fiscalCode"];
        }
    }

    static fromJS(data: any): FiscalCode {
        data = typeof data === 'object' ? data : {};
        let result = new FiscalCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fiscalCode"] = this.fiscalCode;
        return data; 
    }
}

export interface IFiscalCode {
    fiscalCode: string;
}

export class FiscalCodeData implements IFiscalCodeData {
    readonly birthCity?: string | undefined;
    readonly birthDate?: Date | undefined;
    readonly sex?: FiscalCodeDataSex | undefined;

    constructor(data?: IFiscalCodeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).birthCity = _data["birthCity"];
            (<any>this).birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            (<any>this).sex = _data["sex"];
        }
    }

    static fromJS(data: any): FiscalCodeData {
        data = typeof data === 'object' ? data : {};
        let result = new FiscalCodeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birthCity"] = this.birthCity;
        data["birthDate"] = this.birthDate ? formatDate(this.birthDate) : <any>undefined;
        data["sex"] = this.sex;
        return data; 
    }
}

export interface IFiscalCodeData {
    birthCity?: string | undefined;
    birthDate?: Date | undefined;
    sex?: FiscalCodeDataSex | undefined;
}

export class FileToken implements IFileToken {
    token!: string;
    readonly url?: string | undefined;
    expiration!: Date;
    fileType!: string;
    fileId!: number;
    mimeType!: string;

    constructor(data?: IFileToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            (<any>this).url = _data["url"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            this.fileType = _data["fileType"];
            this.fileId = _data["fileId"];
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): FileToken {
        data = typeof data === 'object' ? data : {};
        let result = new FileToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["url"] = this.url;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        data["fileType"] = this.fileType;
        data["fileId"] = this.fileId;
        data["mimeType"] = this.mimeType;
        return data; 
    }
}

export interface IFileToken {
    token: string;
    url?: string | undefined;
    expiration: Date;
    fileType: string;
    fileId: number;
    mimeType: string;
}

export class JitsiRoomData implements IJitsiRoomData {
    server!: string;
    jwt!: string;
    room!: string;

    constructor(data?: IJitsiRoomData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.server = _data["server"];
            this.jwt = _data["jwt"];
            this.room = _data["room"];
        }
    }

    static fromJS(data: any): JitsiRoomData {
        data = typeof data === 'object' ? data : {};
        let result = new JitsiRoomData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["server"] = this.server;
        data["jwt"] = this.jwt;
        data["room"] = this.room;
        return data; 
    }
}

export interface IJitsiRoomData {
    server: string;
    jwt: string;
    room: string;
}

export class Unit implements IUnit {
    readonly id?: number | undefined;
    name!: string;
    emergencyRoom?: boolean | undefined;

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.name = _data["name"];
            this.emergencyRoom = _data["emergencyRoom"];
        }
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["emergencyRoom"] = this.emergencyRoom;
        return data; 
    }
}

export interface IUnit {
    id?: number | undefined;
    name: string;
    emergencyRoom?: boolean | undefined;
}

export class Patient implements IPatient {
    readonly id?: number | undefined;
    firstName!: string;
    lastName!: string;
    unit!: Unit;
    remainingQuestions!: number;
    remainingPatientMessages!: number;

    constructor(data?: IPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.unit = new Unit();
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : new Unit();
            this.remainingQuestions = _data["remainingQuestions"];
            this.remainingPatientMessages = _data["remainingPatientMessages"];
        }
    }

    static fromJS(data: any): Patient {
        data = typeof data === 'object' ? data : {};
        let result = new Patient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        data["remainingQuestions"] = this.remainingQuestions;
        data["remainingPatientMessages"] = this.remainingPatientMessages;
        return data; 
    }
}

export interface IPatient {
    id?: number | undefined;
    firstName: string;
    lastName: string;
    unit: Unit;
    remainingQuestions: number;
    remainingPatientMessages: number;
}

export class PendingPatient implements IPendingPatient {
    firstName!: string;
    lastName!: string;

    constructor(data?: IPendingPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): PendingPatient {
        data = typeof data === 'object' ? data : {};
        let result = new PendingPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data; 
    }
}

export interface IPendingPatient {
    firstName: string;
    lastName: string;
}

export class Identity implements IIdentity {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    patients!: Patient[];
    pendingPatients!: PendingPatient[];

    constructor(data?: IIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.patients = [];
            this.pendingPatients = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients!.push(Patient.fromJS(item));
            }
            if (Array.isArray(_data["pendingPatients"])) {
                this.pendingPatients = [] as any;
                for (let item of _data["pendingPatients"])
                    this.pendingPatients!.push(PendingPatient.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Identity {
        data = typeof data === 'object' ? data : {};
        let result = new Identity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        if (Array.isArray(this.pendingPatients)) {
            data["pendingPatients"] = [];
            for (let item of this.pendingPatients)
                data["pendingPatients"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIdentity {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    patients: Patient[];
    pendingPatients: PendingPatient[];
}

export class RecoveryPassword implements IRecoveryPassword {
    email!: string;

    constructor(data?: IRecoveryPassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): RecoveryPassword {
        data = typeof data === 'object' ? data : {};
        let result = new RecoveryPassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data; 
    }
}

export interface IRecoveryPassword {
    email: string;
}

export class RegisterDevice implements IRegisterDevice {
    deviceRegistrationId!: string;

    constructor(data?: IRegisterDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceRegistrationId = _data["deviceRegistrationId"];
        }
    }

    static fromJS(data: any): RegisterDevice {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceRegistrationId"] = this.deviceRegistrationId;
        return data; 
    }
}

export interface IRegisterDevice {
    deviceRegistrationId: string;
}

export class UploadRegistrationFile implements IUploadRegistrationFile {
    readonly uuid?: string | undefined;
    file?: string | undefined;

    constructor(data?: IUploadRegistrationFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).uuid = _data["uuid"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): UploadRegistrationFile {
        data = typeof data === 'object' ? data : {};
        let result = new UploadRegistrationFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uuid"] = this.uuid;
        data["file"] = this.file;
        return data; 
    }
}

export interface IUploadRegistrationFile {
    uuid?: string | undefined;
    file?: string | undefined;
}

export class RelativeRegistration implements IRelativeRegistration {
    documentFront!: string;
    documentBack!: string;
    selfie!: string;
    smsToken!: string;
    isEmergencyRoom!: boolean;
    confirmCriminalPenalties!: boolean;
    confirmClosestRelative!: boolean;
    confirmPersonalData!: boolean;
    confirmPrivacy!: boolean;
    confirmEmail!: boolean;
    confirmDataIsCorrect!: boolean;
    confirmServiceActivation!: boolean;
    confirmTermsAndAgreements!: boolean;
    email!: string;
    firstName!: string;
    lastName!: string;
    password!: string;
    fiscalCode!: string;
    phone!: string;
    documentType!: RelativeRegistrationDocumentType;
    relation!: RelativeRegistrationRelation;
    token?: string | undefined;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    patientFiscalCode?: string | undefined;
    secondPhone?: string | undefined;
    birthMunicipality?: string | undefined;
    patientBirthCity?: string | undefined;

    constructor(data?: IRelativeRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentFront = _data["documentFront"];
            this.documentBack = _data["documentBack"];
            this.selfie = _data["selfie"];
            this.smsToken = _data["smsToken"];
            this.isEmergencyRoom = _data["isEmergencyRoom"];
            this.confirmCriminalPenalties = _data["confirmCriminalPenalties"];
            this.confirmClosestRelative = _data["confirmClosestRelative"];
            this.confirmPersonalData = _data["confirmPersonalData"];
            this.confirmPrivacy = _data["confirmPrivacy"];
            this.confirmEmail = _data["confirmEmail"];
            this.confirmDataIsCorrect = _data["confirmDataIsCorrect"];
            this.confirmServiceActivation = _data["confirmServiceActivation"];
            this.confirmTermsAndAgreements = _data["confirmTermsAndAgreements"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.password = _data["password"];
            this.fiscalCode = _data["fiscalCode"];
            this.phone = _data["phone"];
            this.documentType = _data["documentType"];
            this.relation = _data["relation"];
            this.token = _data["token"];
            this.patientFirstName = _data["patientFirstName"];
            this.patientLastName = _data["patientLastName"];
            this.patientFiscalCode = _data["patientFiscalCode"];
            this.secondPhone = _data["secondPhone"];
            this.birthMunicipality = _data["birthMunicipality"];
            this.patientBirthCity = _data["patientBirthCity"];
        }
    }

    static fromJS(data: any): RelativeRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new RelativeRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentFront"] = this.documentFront;
        data["documentBack"] = this.documentBack;
        data["selfie"] = this.selfie;
        data["smsToken"] = this.smsToken;
        data["isEmergencyRoom"] = this.isEmergencyRoom;
        data["confirmCriminalPenalties"] = this.confirmCriminalPenalties;
        data["confirmClosestRelative"] = this.confirmClosestRelative;
        data["confirmPersonalData"] = this.confirmPersonalData;
        data["confirmPrivacy"] = this.confirmPrivacy;
        data["confirmEmail"] = this.confirmEmail;
        data["confirmDataIsCorrect"] = this.confirmDataIsCorrect;
        data["confirmServiceActivation"] = this.confirmServiceActivation;
        data["confirmTermsAndAgreements"] = this.confirmTermsAndAgreements;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["password"] = this.password;
        data["fiscalCode"] = this.fiscalCode;
        data["phone"] = this.phone;
        data["documentType"] = this.documentType;
        data["relation"] = this.relation;
        data["token"] = this.token;
        data["patientFirstName"] = this.patientFirstName;
        data["patientLastName"] = this.patientLastName;
        data["patientFiscalCode"] = this.patientFiscalCode;
        data["secondPhone"] = this.secondPhone;
        data["birthMunicipality"] = this.birthMunicipality;
        data["patientBirthCity"] = this.patientBirthCity;
        return data; 
    }
}

export interface IRelativeRegistration {
    documentFront: string;
    documentBack: string;
    selfie: string;
    smsToken: string;
    isEmergencyRoom: boolean;
    confirmCriminalPenalties: boolean;
    confirmClosestRelative: boolean;
    confirmPersonalData: boolean;
    confirmPrivacy: boolean;
    confirmEmail: boolean;
    confirmDataIsCorrect: boolean;
    confirmServiceActivation: boolean;
    confirmTermsAndAgreements: boolean;
    email: string;
    firstName: string;
    lastName: string;
    password: string;
    fiscalCode: string;
    phone: string;
    documentType: RelativeRegistrationDocumentType;
    relation: RelativeRegistrationRelation;
    token?: string | undefined;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    patientFiscalCode?: string | undefined;
    secondPhone?: string | undefined;
    birthMunicipality?: string | undefined;
    patientBirthCity?: string | undefined;
}

export class PatientTransferTokenValidationRequest implements IPatientTransferTokenValidationRequest {
    token!: string;

    constructor(data?: IPatientTransferTokenValidationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): PatientTransferTokenValidationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PatientTransferTokenValidationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data; 
    }
}

export interface IPatientTransferTokenValidationRequest {
    token: string;
}

export class PatientTransferTokenValidationResponse implements IPatientTransferTokenValidationResponse {
    expiration!: Date;
    patientFirstName!: string;
    patientLastName!: string;
    patientFiscalCode!: string;

    constructor(data?: IPatientTransferTokenValidationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            this.patientFirstName = _data["patientFirstName"];
            this.patientLastName = _data["patientLastName"];
            this.patientFiscalCode = _data["patientFiscalCode"];
        }
    }

    static fromJS(data: any): PatientTransferTokenValidationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientTransferTokenValidationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        data["patientFirstName"] = this.patientFirstName;
        data["patientLastName"] = this.patientLastName;
        data["patientFiscalCode"] = this.patientFiscalCode;
        return data; 
    }
}

export interface IPatientTransferTokenValidationResponse {
    expiration: Date;
    patientFirstName: string;
    patientLastName: string;
    patientFiscalCode: string;
}

export class PatientTransferRequest implements IPatientTransferRequest {
    token!: string;
    relation!: PatientTransferRequestRelation;
    confirmClosestRelative!: boolean;
    confirmPersonalData!: boolean;
    confirmPrivacy!: boolean;
    confirmEmail!: boolean;

    constructor(data?: IPatientTransferRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.relation = _data["relation"];
            this.confirmClosestRelative = _data["confirmClosestRelative"];
            this.confirmPersonalData = _data["confirmPersonalData"];
            this.confirmPrivacy = _data["confirmPrivacy"];
            this.confirmEmail = _data["confirmEmail"];
        }
    }

    static fromJS(data: any): PatientTransferRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PatientTransferRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["relation"] = this.relation;
        data["confirmClosestRelative"] = this.confirmClosestRelative;
        data["confirmPersonalData"] = this.confirmPersonalData;
        data["confirmPrivacy"] = this.confirmPrivacy;
        data["confirmEmail"] = this.confirmEmail;
        return data; 
    }
}

export interface IPatientTransferRequest {
    token: string;
    relation: PatientTransferRequestRelation;
    confirmClosestRelative: boolean;
    confirmPersonalData: boolean;
    confirmPrivacy: boolean;
    confirmEmail: boolean;
}

export class RequestPatientTransferRequest implements IRequestPatientTransferRequest {
    confirmTermsAndAgreements!: boolean;

    constructor(data?: IRequestPatientTransferRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.confirmTermsAndAgreements = _data["confirmTermsAndAgreements"];
        }
    }

    static fromJS(data: any): RequestPatientTransferRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPatientTransferRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmTermsAndAgreements"] = this.confirmTermsAndAgreements;
        return data; 
    }
}

export interface IRequestPatientTransferRequest {
    confirmTermsAndAgreements: boolean;
}

export class RequestPatientTransferResponse implements IRequestPatientTransferResponse {
    token!: string;
    readonly qrCode?: string | undefined;

    constructor(data?: IRequestPatientTransferResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            (<any>this).qrCode = _data["qrCode"];
        }
    }

    static fromJS(data: any): RequestPatientTransferResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPatientTransferResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["qrCode"] = this.qrCode;
        return data; 
    }
}

export interface IRequestPatientTransferResponse {
    token: string;
    qrCode?: string | undefined;
}

export class SendSmsVerification implements ISendSmsVerification {
    phone!: string;

    constructor(data?: ISendSmsVerification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): SendSmsVerification {
        data = typeof data === 'object' ? data : {};
        let result = new SendSmsVerification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        return data; 
    }
}

export interface ISendSmsVerification {
    phone: string;
}

export class UploadFile implements IUploadFile {
    readonly id?: number | undefined;
    file?: string | undefined;

    constructor(data?: IUploadFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): UploadFile {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["file"] = this.file;
        return data; 
    }
}

export interface IUploadFile {
    id?: number | undefined;
    file?: string | undefined;
}

export class VerifySmsTokenRequest implements IVerifySmsTokenRequest {
    phone!: string;
    verificationToken!: string;

    constructor(data?: IVerifySmsTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"];
            this.verificationToken = _data["verificationToken"];
        }
    }

    static fromJS(data: any): VerifySmsTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySmsTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["verificationToken"] = this.verificationToken;
        return data; 
    }
}

export interface IVerifySmsTokenRequest {
    phone: string;
    verificationToken: string;
}

export class VerifySmsTokenResponse implements IVerifySmsTokenResponse {
    token!: string;
    phoneNumber!: string;

    constructor(data?: IVerifySmsTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): VerifySmsTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySmsTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }
}

export interface IVerifySmsTokenResponse {
    token: string;
    phoneNumber: string;
}

export enum RelativeAssociationRequestRelation {
    Spouse = "spouse",
    Son = "son",
    Parent = "parent",
    Sibling = "sibling",
    Tutor = "tutor",
    Cohabitant = "cohabitant",
    Other = "other",
}

export enum ContentType {
    Operator_message = "operator_message",
    Relative_question = "relative_question",
    Patient_message = "patient_message",
    Videocall = "videocall",
}

export enum FiscalCodeDataSex {
    M = "m",
    F = "f",
}

export enum RelativeRegistrationDocumentType {
    Idcard = "idcard",
    Passport = "passport",
    Drivers = "drivers",
    Staypermit = "staypermit",
}

export enum RelativeRegistrationRelation {
    Spouse = "spouse",
    Son = "son",
    Parent = "parent",
    Sibling = "sibling",
    Tutor = "tutor",
    Cohabitant = "cohabitant",
    Other = "other",
}

export enum PatientTransferRequestRelation {
    Spouse = "spouse",
    Son = "son",
    Parent = "parent",
    Sibling = "sibling",
    Tutor = "tutor",
    Cohabitant = "cohabitant",
    Other = "other",
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}